"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNearestTimeToCurrentTime = getNearestTimeToCurrentTime;
var convertTo12Hour_1 = require("./convertTo12Hour");
var timeToMinutes_1 = require("./timeToMinutes");
function getNearestTimeToCurrentTime(timeArray) {
    var currentTime = new Date();
    var hours = currentTime.getHours().toString().padStart(2, "0");
    var minutes = currentTime.getMinutes().toString().padStart(2, "0");
    // let's format time to match timeArray so it can be compared, example 00:00 = 12:00 AM
    var formattedTime = (0, convertTo12Hour_1.convertTo12Hour)("".concat(hours, ":").concat(minutes));
    //format time to minutes, example, formatedTime === 12:45 AM, it will converted to "765", with help of timeToMinutes()
    var formattedTimeMinutes = (0, timeToMinutes_1.timeToMinutes)(formattedTime);
    var nearestTime = timeArray[0];
    // now find minimum difference between current form formattedTimeMinutes and timeArray[0]
    var minDifference = Math.abs(formattedTimeMinutes - (0, timeToMinutes_1.timeToMinutes)(timeArray[0]));
    for (var i = 1; i < timeArray.length; i++) {
        var currentDifference = Math.abs(formattedTimeMinutes - (0, timeToMinutes_1.timeToMinutes)(timeArray[i]));
        if (currentDifference < minDifference) {
            nearestTime = timeArray[i];
            minDifference = currentDifference;
        }
    }
    return nearestTime;
}
